<template>
  <div class="columns is-multiline is-mobile proposal-nav is-gapless">
    <template v-if="!reverseButtons">
      <div v-if="prev" class="column" v-bind:class="{ 'is-half': isSingleRow, 'mb-10' : this.prev && !this.isSingleRow }">
        <template v-if="prevText === 'Geri Dön'">
          <button type="button" class="button is-light is-large is-fullwidth" @click="$emit('prev')">{{ $t('buttons.goBack') }}</button>
        </template>
        <template v-if="prevText !== 'Geri Dön'">
          <button type="button" class="button is-light is-large is-fullwidth" @click="$emit('prev')">{{ prevText }}</button>
        </template>
      </div>
      <div class="column" v-bind:class="{ 'is-half': this.prev && this.isSingleRow }">
        <template v-if="nextText === 'Devam' && !proposal">
          <button type="submit" class="button is-primary is-large is-fullwidth" v-bind:class="{'is-disabled': !nextActive}">{{ $t('buttons.continue') }}</button>        
        </template>
        <template v-if="proposal">
          <button type="submit" class="button is-primary is-large is-fullwidth" v-bind:class="{'is-disabled': !nextActive}">{{ $t('buttons.createProposal') }}</button>        
        </template>
        <template v-if="nextText !== 'Devam' && !proposal">
          <button type="submit" class="button is-primary is-large is-fullwidth" id="new-proposal-button" v-bind:class="{'is-disabled': !nextActive}">{{ nextText }}</button>
        </template>      
      </div>
    </template>
    <template v-if="reverseButtons">
      <div class="column" v-bind:class="{ 'is-half': this.prev && this.isSingleRow }">
        <template v-if="nextText === 'Devam' && !proposal">
          <button type="submit" class="button is-primary is-large is-fullwidth" v-bind:class="{'is-disabled': !nextActive}">{{ $t('buttons.continue') }}</button>        
        </template>
        <template v-if="proposal">
          <button type="submit" class="button is-primary is-large is-fullwidth" v-bind:class="{'is-disabled': !nextActive}">{{ $t('buttons.createProposal') }}</button>        
        </template>
        <template v-if="nextText !== 'Devam' && !proposal">
          <button type="submit" class="button is-primary is-large is-fullwidth" v-bind:class="{'is-disabled': !nextActive}">{{ nextText }}</button>
        </template>      
      </div>
      <div v-if="prev" class="column" v-bind:class="{ 'is-half': isSingleRow, 'mb-10' : this.prev && !this.isSingleRow }">
        <template v-if="prevText === 'Geri Dön'">
          <button type="button" class="button is-light is-large is-fullwidth" @click="$emit('prev')">{{ $t('buttons.goBack') }}</button>
        </template>
        <template v-if="prevText !== 'Geri Dön'">
          <button type="button" class="button is-light is-large is-fullwidth" @click="$emit('prev')">{{ prevText }}</button>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'ProposalButtons',
  data () {
    return {}
  },
  props: {
    prev: {
      default: true,
      type: Boolean
    },
    proposal: {
      default: false,
      type: Boolean
    },
    prevText: {
      default: 'Geri Dön',
      type: String
    },
    nextActive: {
      default: true,
      type: Boolean
    },
    nextText: {
      default: 'Devam',
      type: String
    },
    isSingleRow: {
      default: true,
      type: Boolean
    },
    reverseButtons: {
      default: false,
      type: Boolean
    }
  }
}
</script>
<style scoped>
.proposal-nav .column.is-half:nth-child(odd) {
  padding-right: 5px;
}
.proposal-nav .column.is-half:nth-child(even) {
  padding-left: 5px;
}
.mb-10 button {
  margin-bottom: 10px
}
</style>



// WEBPACK FOOTER //
// src/shared/widget/proposal/buttons.vue